import React from "react";
import { Briefcase, LockOpen, Lock } from "@phosphor-icons/react";
import { Loader2 } from "lucide-react";
import { getVacancies } from "../../adapters/Requests";

function VacancySummary() {
  const {
    data: vacancies,
    isLoading,
    isError,
  } = getVacancies();

  const normalizedVacancies = Array.isArray(vacancies) ? vacancies : [];
  const now = new Date();
  const isVacancyClosed = (vacancy) => {
    const status = String(vacancy?.status || "").trim().toUpperCase();
    if (status === "CLOSED") return true;

    if (vacancy?.closing_date) {
      const closingDate = new Date(vacancy.closing_date);
      return !Number.isNaN(closingDate.getTime()) && closingDate < now;
    }

    return false;
  };

  const totalCount = normalizedVacancies.length;
  const closedCount = normalizedVacancies.filter(isVacancyClosed).length;
  const openCount = Math.max(totalCount - closedCount, 0);

  if (isLoading) {
    return (
      <div className="flex items-center justify-center w-full h-32">
        <Loader2 className="w-8 h-8 text-green-600 animate-spin" />
      </div>
    );
  }

  if (isError) {
    return (
      <div className="flex items-center justify-center w-full">
        <h1>An error occurred, please refresh or go back</h1>
      </div>
    );
  }

  const stats = [
    {
      label: "Total Vacancies",
      value: totalCount,
      icon: Briefcase,
      color: "text-slate-700",
      bg: "bg-slate-100",
    },
    {
      label: "Open Vacancies",
      value: openCount,
      icon: LockOpen,
      color: "text-green-600",
      bg: "bg-green-100",
    },
    {
      label: "Closed Vacancies",
      value: closedCount,
      icon: Lock,
      color: "text-gray-600",
      bg: "bg-gray-100",
    },
  ];

  return (
    <div className="w-full mt-6 max-w-[95%] xl:max-w-[70%] mx-auto mb-3">
      <div className="flex items-center justify-between mb-3">
        <h2 className="text-sm font-semibold text-slate-500 uppercase tracking-wider ml-1">
          Vacancies Overview
        </h2>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        {stats.map((stat, index) => (
          <div
            key={index}
            className="flex flex-col items-center justify-center p-3 rounded-lg border border-slate-100 bg-slate-50 cursor-default select-none"
          >
            <div
              className={`h-8 w-8 rounded-full flex items-center justify-center mb-2 ${stat.bg} ${stat.color}`}
            >
              <stat.icon size={16} weight="fill" />
            </div>
            <h3 className="text-lg font-bold text-slate-700 leading-none">
              {stat.value}
            </h3>
            <p className="text-[10px] font-medium text-slate-500 uppercase tracking-wide mt-1">
              {stat.label}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}

export default VacancySummary;
